import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

/** Den offenen Zustand haelt der Runner: er klappt den Block beim Wechsel des Testfalls wieder ein. */
@Component({
  selector: 'app-runner-preconditions',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './runner-preconditions.component.html',
  styleUrl: './runner-preconditions.component.scss',
})
export class RunnerPreconditionsComponent {
  readonly text = input.required<string>();
  readonly open = input.required<boolean>();
  readonly toggled = output<void>();
}
